<div class="container">
  <div *ngIf="!currentUser" class="row">
    <div class="col-12 mb-40">
          <h2>{{ 'history.account.title' | translate}}</h2>
          <p>{{ 'history.account.description' | translate}}</p>
          <button class="btn btn-primary" [routerLink]="['/register/.']">{{ 'history.account.register' | translate}}</button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h2>{{ 'history.statistics.title' | translate}}</h2>
      <p class="lead mb-4 text-muted">{{ 'history.statistics.subtitle' | translate }}</p>
    </div>
  </div>
  <div class="row mb-20">
    <div class="col-12 col-sm-6 col-lg-3 mb-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'history.statistics.cards.0.title' | translate}}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ 'history.statistics.cards.0.subtitle' | translate}}</h6><br>
          <div *ngIf="!didLoad">
            <div class="spinner secondary-yellow-bgr"></div>
          </div>
          <div *ngIf="didLoad">
            <p class="card-text font-38 secondary-yellow">{{ numberOfTests }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 mb-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'history.statistics.cards.1.title' | translate}}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ 'history.statistics.cards.1.subtitle' | translate}}</h6><br>
          <div *ngIf="!didLoad">
            <div class="spinner secondary-pink-bgr"></div>
          </div>
          <div *ngIf="didLoad">
            <p class="card-text"><span class="font-38 secondary-pink">{{ pingAverage }}</span> ms</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 mb-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'history.statistics.cards.2.title' | translate}}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ 'history.statistics.cards.2.subtitle' | translate}}</h6><br>
          <div *ngIf="!didLoad">
            <div class="spinner secondary-blue-bgr"></div>
          </div>
          <div *ngIf="didLoad">
            <p class="card-text"><span class="font-38 secondary-blue">{{ downloadAverage }}</span> Mbps</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-lg-3 mb-20">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ 'history.statistics.cards.3.title' | translate}}</h5>
          <h6 class="card-subtitle mb-2 text-muted">{{ 'history.statistics.cards.3.subtitle' | translate}}</h6><br>
          <div *ngIf="!didLoad">
            <div class="spinner secondary-purple-bgr"></div>
          </div>
          <div *ngIf="didLoad">
            <p class="card-text"><span class="font-38 secondary-purple">{{ uploadAverage }}</span> Mbps</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h2>{{ 'history.trend.title' | translate}}</h2>
      <p class="lead mb-4 text-muted">{{ 'history.trend.subtitle' | translate}}</p>
    </div>
  </div>
  <div class="row mb-40">
    <div class="col-12">
        <div *ngIf="!didLoad" class="m-b-30">
          <div class="spinner primary-dark-bgr"></div>
        </div>
        <div *ngIf="didLoad">
          <canvas id="canvas">{{ chart }}</canvas>
        </div>
    </div>  
  </div>
  
  <div class="row">
    <div class="col-12 col-sm-6">
      <h2>{{ 'history.results.title' | translate}}</h2>
      <p class="lead mb-4 text-muted">{{ 'history.results.subtitle' | translate}}</p>
    </div>
    <div class="col-12 col-sm-6">
      <p class="lead mb-4 text-muted">

        <button type="button" class="btn btn-primary toggle-filter" (click)="isCollapsed = !isCollapsed">{{ 'history.results.filter.button' | translate }}</button>
        <button type="button" class="btn btn-primary toggle-filter" (click)="loadPDF()" style="margin-right: 10px; margin-left: 10px">Create PDF</button>
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div (collapsed)="collapsed($event)" (expanded)="expanded($event)" [collapse]="isCollapsed">
        <div class="row">
          <div class="col-12 col-sm-6 mb-20">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ 'history.results.filter.date.title' | translate }}</h5>
                <button type="button" class="btn btn-danger" style="margin-top: -36px; float: right;" (click)="reset()">{{ 'history.results.filter.date.clear' | translate }}</button>
                <h6 class="card-subtitle mb-2 text-muted">{{ 'history.results.filter.date.subtitle' | translate }}</h6><br>
                <input type="text"
                       placeholder="{{ 'history.results.filter.date.datepicker' | translate }}"
                       class="form-control"
                       [(ngModel)]="dateValue"
                       (ngModelChange)="onInputChanged( $event )"
                       [bsConfig] ="{ containerClass: 'theme-default'}"
                       bsDaterangepicker>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-20">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ 'history.results.filter.isp.title' | translate }}</h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ 'history.results.filter.isp.subtitle' | translate }}</h6><br>
                <ng-select [items]="ispSet"
                           [multiple]="true"
                           (change)="ispSelectOnChange($event)"
                           bindLabel="value"
                           bindValue="id"
                           placeholder="{{ 'history.results.filter.isp.isppicker' | translate }}"
                           [(ngModel)]="selectedIspId">
                </ng-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-40" *ngIf="rows.length==0">
    <div class="col-12">
      <p class="lead text-muted" style="text-align: center;">{{ 'history.results.zero' | translate }}</p>
      <a class="nav-link center" [routerLink]="['/']">{{ 'history.results.button' | translate }}</a>
    </div>
  </div>

  <div class="row mb-40" *ngIf="rows.length>0">
    <div class="col-12">
      <div *ngIf="!didLoad">
        <div class="spinner primary-dark-bgr center"></div>
      </div>
      <div *ngIf="didLoad" class="mb-20">
          <ngx-datatable
            class="bootstrap"
            [rows]="rows"
            [selected]="selectedRows"
            [columns]="columns"
            [columnMode]="'force'"
            [scrollbarH]="true"
            [headerHeight]="40"
            [footerHeight]="40"
            [limit]="10"
            [rowHeight]="'auto'"
            [sorts]="[{prop: 'testDate', dir: 'desc'}]">
            <ngx-datatable-column prop="testDate" headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.0.header' | translate }}</span>
              </ng-template>
              <ng-template let-value="value" ngx-datatable-cell-template>
                  <span [innerHTML]="value | date: 'dd/MM/yyyy'"></span>
                  <br>
                  <span [innerHTML]="value | date: 'hh:mm:ss'"></span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="ping" name="Ping [ms]" headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.1.header' | translate }} [ms]</span>
              </ng-template>
              <ng-template let-value="value" ngx-datatable-cell-template>
                  {{ value | number: '1.0-0' }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="download" name="Download [Mbps]" headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.2.header' | translate }} [Mbps]</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="upload" name="Upload [Mbps]" headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.3.header' | translate }} [Mbps]</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="isp.isp" name="ISP" headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.4.header' | translate }}</span>
              </ng-template>
            </ngx-datatable-column>
             <ngx-datatable-column headerClass="header-center" cellClass="pd-r">
              <ng-template let-column="column" ngx-datatable-header-template>
                <span>{{ 'history.results.table.5.header' | translate }}</span>
              </ng-template>
                <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                    <i *ngIf="true" class="fa fa-2x fa-trash pointer" (click)="delete(row)"></i>
                </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-sm-6">
      <p class="lead mb-4 text-muted"><button type="button" class="btn btn-primary" (click)="loadPDF()">Create PDF</button></p>
    </div>
  </div>

</div>

